import React from "react";
import style from "../../Assets/css/b2bTestimonial.module.css";
import rec_1 from "../../Assets/img/Rectangle 1055.png";
import rec_2 from "../../Assets/img/Rectangle 1056.png";
import rec_3 from "../../Assets/img/Rectangle 1057.png";

const b2bTestimonials = () => {
	return (
		<>
			<div class={`container-fluid ${style.section1_J}`}>
				<div>
					<div
						class={`row justify-content-around ${style.MNC_J} mx-xl-5 mx-lg-5 mx-md-5 mx-sm-2`}
					>
						<div
							class={`col-xl-6 col-lg-6 p-5 mb-4 ${style.second_div_J}`}
						>
							<h2>"Almost everyone got Placed at MNC's</h2>
							<br />
							<div class="d-flex">
								<div class={`${style.yellow_J} mr-3`}></div>
								<h4>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a type specimen book. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged.
								</h4>
							</div>

							<p class={`${style.p_bold_J} ml-4`}>
								<span>Chella </span>Dean IIT Hyderabad
							</p>
						</div>
						<div
							class={`col-xl-4 col-lg-4 p-5 mb-4 ${style.first_div_J} ${style.first_img_J}`}
						>
							<img src={rec_1} class="img-responsive" alt="" />
						</div>
					</div>

					<div
						class={`row justify-content-around image-left ${style.MNC_J} mx-xl-5 mx-lg-5 mx-md-5 mx-sm-2`}
					>
						<div
							class={`col-xl-4 col-lg-4 p-5 mb-4 ${style.first_div_J} ${style.first_img_J}`}
						>
							<img src={rec_2} class="img-responsive" alt="" />
						</div>
						<div
							class={`col-xl-6 col-lg-6 p-5 mb-4 ${style.second_div_J}`}
						>
							<h2>"Almost everyone got Placed at MNC's</h2>
							<br />
							<div class="d-flex">
								<div class={`${style.yellow_J} mr-3`}></div>
								<h4>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a type specimen book. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged.
								</h4>
							</div>

							<p class={`${style.p_bold_J} ml-4`}>
								<span>Chella </span>Dean IIT Hyderabad
							</p>
						</div>
					</div>

					<div
						class={`row justify-content-around ${style.MNC_J} mx-xl-5 mx-lg-5 mx-md-5 mx-sm-2`}
					>
						<div
							class={`col-xl-6 col-lg-6 p-5 mb-4 ${style.second_div_J}`}
						>
							<h2>"Almost everyone got Placed at MNC's</h2>
							<br />
							<div class="d-flex">
								<div class={`${style.yellow_J} mr-3`}></div>
								<h4>
									Lorem Ipsum is simply dummy text of the
									printing and typesetting industry. Lorem
									Ipsum has been the industry's standard dummy
									text ever since the 1500s, when an unknown
									printer took a galley of type and scrambled
									it to make a type specimen book. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged. It has
									survived not only five centuries, but also
									the leap into electronic typesetting,
									remaining essentially unchanged.
								</h4>
							</div>

							<p class={`${style.p_bold_J} ml-4`}>
								<span>Chella </span>Dean IIT Hyderabad
							</p>
						</div>
						<div
							class={`col-xl-4 col-lg-4 p-5 mb-4 ${style.first_div_J} ${style.first_img_J}`}
						>
							<img src={rec_3} class="img-responsive" alt="" />
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default b2bTestimonials;
